<!--Connect: 联系我们 2021/03/25 16:29:47 Sunanguang-->

<template>
   <div class="its-connect">
     <p class="its-connect-title">联系您专属的学科网工作人员获取一对一VIP服务或</p>
     <p class="its-connect-title">致电客服热线<span>400-900-2556</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;座机：<span>010-5834 9377</span></p>
     <button v-if="showApply" class="its-connect-btn" @click="toPath('/apply/submit')">立即申请试用</button>
   </div>
</template>
<script>
export default {
  name: 'Connect',
  props: {
    showApply: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'interact'
    }
  },
  methods: {
    toPath: function (path, tab) {
       if (!tab) {
         tab = this.type
       }
      this.$router.push(path+'?tab=' + tab)
    }
  }
}
</script>

<style scoped>
.its-connect {
  width: 100%;
  text-align: center;
  background-color: #F8F8F8;
  padding-bottom: 38px;
  padding-top: 33px;
}

.its-connect-title {
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #666666;
  font-size: 20px;
}

.its-connect-title span {
  font-size: 36px;
  color: #51A1F7;
  margin-left: 10px;
  vertical-align: bottom;
}

.its-connect-btn {
  background: #FFFFFF;
  border: 2px solid #4C94F7;
  border-radius: 24px;
  width: 210px;
  height: 48px;
  line-height: 44px;
  text-align: center;
  cursor: pointer;
  margin-top: 6px;
  color: #51A1F7;
  font-size: 20px;
}
</style>